import { atom } from "jotai";
import { atomWithInfiniteQuery, queryClientAtom } from "jotai-tanstack-query";
import type { ListDocumentsResponse } from "document-api-client";
import { documentApiService } from "../services/documentApiService";

const getDefaultMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    return `${year}-${month}`;
};

export const selectedMonthAtom = atom<string>(getDefaultMonth());
export const pageSizeAtom = atom<number>(100);

export const documentsQueryAtom = atomWithInfiniteQuery((get) => {
    const selectedMonth = get(selectedMonthAtom);
    const pageSize = get(pageSizeAtom);

    return {
        queryKey: ["documents", selectedMonth],
        queryFn: async ({ pageParam }: { pageParam: string | undefined }) => {
            return await documentApiService.listDocuments({
                yearMonth: selectedMonth,
                limit: pageSize.toString(),
                nextToken: pageParam,
            });
        },
        initialPageParam: undefined,
        getNextPageParam: (lastPage: ListDocumentsResponse) =>
            lastPage.nextToken,
        staleTime: 30 * 1000,
    };
});

export const refetchDocumentsAtom = atom(null, async (get, set) => {
    const queryClient = get(queryClientAtom);
    const selectedMonth = get(selectedMonthAtom);
    await queryClient.invalidateQueries({
        queryKey: ["documents", selectedMonth],
    });
});
